module.exports = __webpack_public_path__ + "static/media/fr.f4529ed8.svg";